// Přepnutí vizualizace zámků v konkrétním legacy okně (Phoenix → Magic `window/toggle-locks`).
// Cílí iframe okna podle layerId přes registr okno↔layerId (jako sendWindowAction).

import { legacyFormSourceRegistry, PHOENIX_TO_MAGIC_ACTIONS } from '@/shared/legacyMagicBridge';

export function sendWindowToggleLocks(layerId: string, enabled: boolean): void {
  const target = legacyFormSourceRegistry.resolveWindow(layerId);
  if (!target) return;
  target.postMessage(
    {
      action: PHOENIX_TO_MAGIC_ACTIONS.windowToggleLocks,
      data: { enabled },
      requestId: crypto.randomUUID(),
    },
    '*'
  );
}
